export const transactionTrackIDs = {
    search: {
        id: 'dagligbank-transaction-search',
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNhY3Rpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ3RtL3RyYWNrSURzL3RyYW5zYWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxNQUFNLG1CQUFtQixHQUFHO0lBQy9CLE1BQU0sRUFBRTtRQUNKLEVBQUUsRUFBRSwrQkFBK0I7S0FDdEM7Q0FDSixDQUFDIn0=